// import { TDADeleteManyFn } from '@/src/@types/data-provider/delete-many'
import deleteManyHeaderImage from '@/src/requests/delete-many-header-image'

export const deleteManyHeaderImage_: any = async (_: any, params: any) => {
  await deleteManyHeaderImage(params.ids)
  return { data: params.ids }
}
